import MuiButton from '@material-ui/core/Button'
import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const Button = withStyles({
  root: {
    fontWeight: 'bold',
  },
})(MuiButton)

export default props => {
  return <Button {...props} />
}
